// The Settings sub-sections, shared between the sidebar (which nests them under the
// Settings item when that section is active) and the settings page (which renders the
// active section's content). Sections are URL-addressable at /admin/settings/:id.
import type { IconName } from '../ui/icons';

export interface SettingsSection {
  id: string;
  labelKey: string; // i18n key, resolved with t() at render time
  icon: IconName;
  requires?: string; // permission flag required to see the section
}

export const SETTINGS_SECTIONS: SettingsSection[] = [
  { id: 'general', labelKey: 'settings.tabs.general', icon: 'home' },
  { id: 'tags', labelKey: 'settings.tabs.tags', icon: 'list' },
  { id: 'dance', labelKey: 'settings.tabs.dance', icon: 'music' },
  { id: 'event-types', labelKey: 'settings.tabs.eventTypes', icon: 'calendar' },
  { id: 'billing', labelKey: 'settings.tabs.billing', icon: 'wallet' },
  { id: 'email', labelKey: 'settings.tabs.email', icon: 'mail' },
  { id: 'media', labelKey: 'settings.tabs.media', icon: 'image' },
  { id: 'calendar', labelKey: 'settings.tabs.calendar', icon: 'clock' },
  { id: 'notifications', labelKey: 'settings.tabs.notifications', icon: 'bell' },
  { id: 'appearance', labelKey: 'settings.tabs.appearance', icon: 'sun' },
  { id: 'features', labelKey: 'settings.tabs.features', icon: 'activity' },
  { id: 'contract', labelKey: 'settings.tabs.contract', icon: 'file' },
  { id: 'backup', labelKey: 'settings.tabs.backup', icon: 'folder', requires: 'system.backup' },
];

export const DEFAULT_SETTINGS_SECTION = 'general';
